import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { Observable, concatMap, take } from 'rxjs';

//* Core
import { ApiCreds, PaystubInfo } from '@core/models';
import { EmployeeProfileService } from '@core/services';

//* Base
import { paystubDownloadUrl } from './constants';
import * as fileSaver from 'file-saver';

@Injectable({ providedIn: 'root' })
export class PaystubDownloadService {
  constructor(private employeeProfileService: EmployeeProfileService, private http: HttpClient) {}

  download(paystubInfo: PaystubInfo) {
    this.fetchPaystubDownload(paystubInfo).subscribe(response => {
      //compose filename from paystub tab data
      const day = formatDate(paystubInfo.day, 'yyyy-MM-dd', 'en-US');
      const fileName = `paystub_${day}.pdf`;

      const blob = new Blob([response], { type: 'application/pdf' });
      fileSaver.saveAs(blob, fileName);
    }),
      (error: Error) => console.log('Error downloading the file', error),
      () => console.log('File downloaded successfully');
  }

  private fetchPaystubDownload(paystubInfo: PaystubInfo): Observable<Blob> {
    //* 1. Collect Employee Api Credentials from Profile Service.
    return this.employeeProfileService.apiCreds$.pipe(
      take(1),
      //* 2. concatMap to allow inner Observable & fetch Data with apiCreds
      concatMap(apiCreds => this.fetchData(apiCreds, paystubInfo))
    );
  }

  /* Fetch Data from API using Employee API Credentials */
  private fetchData(apiCreds: ApiCreds, paystubInfo: PaystubInfo): Observable<Blob> {
    const checkId = paystubInfo?.checkId;
    const didId = paystubInfo.didId;

    //1. Build URL string
    const url = `${paystubDownloadUrl}/${apiCreds.bcl}/${apiCreds.id}/${didId}/${checkId}`;
    //2. Fetch URL string and create Observable with Data.
    return this.http.get(url, { responseType: 'blob' });
  }
}
